/**
 * API Configuration
 * Centralized API URL management for development and production
 */

// Get API URL from environment variable
// In development: uses .env.development (http://localhost:5000/api)
// In production: uses .env.production (your deployed backend URL/api)
const envApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Remove trailing slash if present
export const API_URL = envApiUrl.endsWith('/') ? envApiUrl.slice(0, -1) : envApiUrl;

// Extract base URL (without /api)
export const API_BASE_URL = API_URL.replace(/\/api$/, '');

// Log current configuration (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 API Configuration:');
  console.log('  Environment:', process.env.NODE_ENV);
  console.log('  API Base URL:', API_BASE_URL);
  console.log('  Full API URL:', API_URL);
}

export default {
  API_BASE_URL,
  API_URL,
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};
